import React from "react";
import type Stripe from "stripe";

import { PromoForm as PromoFormA, PromoCoupon as PromoCouponA } from "./PromoFormA";
import { PromoForm as PromoFormB, PromoCoupon as PromoCouponB } from "./PromoFormB";

export interface PromoFormProps {
    verifyPromoCode: (promoCode: Stripe.PromotionCode) => Promise<void>;
}

export function PromoForm({ variant = "A", ...props }: { variant?: "A" | "B" } & PromoFormProps) {
    const Component = variant === "A" ? PromoFormA : PromoFormB;
    return <Component {...props} />;
}

export interface PromoCouponProps {
    coupon: Stripe.Coupon;
}

export function PromoCoupon({ variant = "A", ...props }: { variant?: "A" | "B" } & PromoCouponProps) {
    const Component = variant === "A" ? PromoCouponA : PromoCouponB;
    return <Component {...props} />;
}
